import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';
import { FictitiousProfile } from '../../model/interfaces/FictitiousProfile';

export const key = ['MEMBER'];
export const useGetProfile = (id?: string) =>
  useQuery(
    [...key, id],
    async (): Promise<FictitiousProfile> => {
      const { data } = await axiosInstance.get(`/api/v2/profiles/${id}`);
      return data.data;
    },
    {
      enabled: !!id,
      refetchOnWindowFocus: false
    }
  );
